/**
 * The partner-approved wording an advisor must send for one of the emails their pilot program
 * reviewed, or null when they may write their own.
 *
 * New York Life approves the exact words its agents send, so for those emails the server replaces
 * whatever the browser submits with this text (see `decidePilotCommunication` in
 * `@shared/pilotPrograms`). This hook exists so the email editors show that text, read-only,
 * instead of an editable draft the client would never receive.
 */
import { useSelector } from 'react-redux';
import { getPilotLockedCommunicationBody, type PilotCommunicationKey } from '@shared';
import { selectFeatureFlags } from '@/model/selectors';

export function usePilotLockedEmailBody(key: PilotCommunicationKey): string | null {
  const featureFlags = useSelector(selectFeatureFlags);
  return getPilotLockedCommunicationBody(featureFlags, key);
}
